export const fecalsTests = [
  { id: '5010', description: 'Fecal Ova and Parasites' },
  { id: '5013', description: 'Fecal Dx® Profile' },
  { id: '24639', description: 'Fecal Dx® Profile with Giardia' },
];
